import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { FEATURE_FLAGS, FeatureFlag, Settings } from '../../data/models/models';
import { APP_SETTINGS } from '../../data/settings-data.provider';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  constructor(@Inject(APP_SETTINGS) private readonly settings: Settings) {}

  isAllowed(feature: FeatureFlag): boolean {
    // If no features are defined, all features are allowed
    const availableFeatures = isNil(this.settings.features)
      ? Object.values(FEATURE_FLAGS)
      : this.settings.features;
    return availableFeatures.includes(feature);
  }
}
